import { Link } from "react-router-dom";
import { Phone, Facebook, Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo.avif";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", href: "/" },
    { name: "Services", href: "/services" },
    { name: "Commercial Solutions", href: "/commercial" },
    { name: "Gallery", href: "/gallery" },
    { name: "About Us", href: "/about" },
    { name: "Testimonials", href: "/testimonials" },
    { name: "Contact", href: "/contact" },
  ];

  const services = [
    { name: "Pressure Washing", href: "/services/pressure-washing" },
    { name: "House Washing", href: "/services/house-washing" },
    { name: "Roof Washing / Soft Washing", href: "/services/roof-washing" },
    { name: "Concrete Cleaning & Sealing", href: "/services/concrete-cleaning" },
    { name: "Driveway Cleaning", href: "/services/driveway-cleaning" },
    { name: "Deck Cleaning & Restoration", href: "/services/deck-cleaning" },
    { name: "Patio Cleaning", href: "/services/patio-cleaning" },
    { name: "Sidewalk Cleaning", href: "/services/sidewalk-cleaning" },
    { name: "Gutter Cleaning", href: "/services/gutter-cleaning" },
    { name: "Brick & Paver Cleaning", href: "/services/brick-paver-cleaning" },
    { name: "Rust & Stain Removal", href: "/services/rust-stain-removal" },
    { name: "Vinyl Fence Cleaning", href: "/services/vinyl-fence-cleaning" },
    { name: "Wood Restoration", href: "/services/wood-restoration" },
    { name: "Oxidation Removal", href: "/services/oxidation-removal" },
    { name: "Commercial Services", href: "/services/commercial" },
    { name: "Dumpster Pad Cleaning", href: "/services/dumpster-pad-cleaning" },
    { name: "Fleet Washing", href: "/services/fleet-washing" },
  ];

  const serviceAreas = [
    "Inwood, WV", "Martinsburg, WV", "Falling Waters, WV", "Hedgesville, WV",
    "Berkeley Springs, WV", "Charles Town, WV", "Ranson, WV", "Kearneysville, WV",
    "Winchester, VA", "Harpers Ferry, WV", "Bunker Hill, WV", "Shepherdstown, WV",
    "Berryville, VA", "Stephens City, VA",
  ];

  return (
    <footer className="bg-secondary text-secondary-foreground">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Link to="/">
              <img src={logo} alt="Stream Masters Power Washing" width={200} height={80} loading="lazy" className="h-16 w-auto mb-2" />
            </Link>
            <h3 className="text-lg font-bold font-heading text-white mb-3">Stream Masters Power Washing</h3>
            <div className="space-y-3 text-gray-300">
              <p className="flex items-center gap-2"><span className="text-primary">✓</span> Licensed & Insured</p>
              <p className="flex items-center gap-2"><span className="text-primary">✓</span> Veteran Owned</p>
              <p className="flex items-center gap-2"><span className="text-primary">✓</span> Operated by Firemen</p>
              <p className="text-sm mt-4">Serving MD, WV & VA with professional power washing services.</p>
            </div>
            <div className="flex items-center gap-4 mt-6">
              <a href="https://www.facebook.com/share/17qEwQT9Fd/?mibextid=wwXlfr" target="_blank" rel="noopener noreferrer" className="p-2 bg-primary/10 rounded-full hover:bg-primary/20 transition-colors" aria-label="Visit our Facebook page">
                <Facebook className="w-5 h-5 text-primary" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold font-heading mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}><Link to={link.href} className="text-gray-300 hover:text-primary transition-colors">{link.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold font-heading mb-6 text-white">Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.href}><Link to={service.href} className="text-gray-300 hover:text-primary transition-colors">{service.name}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold font-heading mb-6 text-white">Contact Us</h3>
            <div className="space-y-4">
              <a href="tel:+12762123137" className="flex items-center gap-3 text-gray-300 hover:text-primary transition-colors">
                <Phone className="w-5 h-5 text-primary" />
                (276) 212-3137
              </a>
              <p className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-1" />
                <span>Serving Berkeley County WV, Jefferson County WV, Frederick County VA, Washington County MD & surrounding areas</span>
              </p>
              <div className="pt-4">
                <p className="text-primary font-semibold mb-2">🎖️ 10% Military & First Responder Discount</p>
                <p className="text-sm text-gray-300">Free Estimates & Consultations</p>
              </div>
            </div>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-white mb-3">Service Areas</h4>
              <p className="text-sm text-gray-300">{serviceAreas.join(" • ")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400">© {currentYear} Stream Masters Power Washing. All Rights Reserved.</p>
            <div className="flex items-center gap-4 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms-of-service" className="hover:text-primary transition-colors">Terms of Service</Link>
              <span>|</span>
              <Link to="/accessibility" className="hover:text-primary transition-colors">Accessibility</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;